export default __webpack_public_path__ + "static/media/icon-approved.0557d3a0.svg";